export default {
    isShowAppointments: state => state.appointmentsIsShow,
    isShowAttendance: state => state.attendanceIsShow,
    getAppointmentData: state => state.appointmentObject
}
